import {
  createConduitGatewayFetcher,
  createFrontendConfigurationServiceFetcher,
  createPaymentApiFetcher,
  createUserManagementServiceFetcher,
} from "./fetchers";
import {
  envelopedListResponse,
  envelopedResponse,
  rawResponse,
  unenvelopedResponse,
} from "./httpClient/responseHandlers";
import * as responseSchemas from "./response-schemas";
import * as requestTemplates from "./request-templates";

// payment_api

export const getCurrentUser = createPaymentApiFetcher(
  requestTemplates.currentUser,
  envelopedResponse(responseSchemas.USER)
);

export const getAgencies = createPaymentApiFetcher(
  requestTemplates.agencies,
  envelopedResponse(responseSchemas.AGENCIES)
);

export const getPayment = createPaymentApiFetcher(
  requestTemplates.payment,
  envelopedResponse(responseSchemas.PAYMENT)
);

export const transactionSearch = createPaymentApiFetcher(
  requestTemplates.transactionSearch,
  envelopedResponse(responseSchemas.PAYMENTS_SEARCH)
);

export const translateTransactionSearch = createPaymentApiFetcher(
  requestTemplates.translateTransactionSearch,
  rawResponse
);

export const customerSearchAsOkta = createPaymentApiFetcher(
  requestTemplates.customerSearchAsOkta,
  envelopedListResponse(responseSchemas.CUSTOMER, responseSchemas.CUSTOMER_META)
);

export const getPaymentReceipt = createPaymentApiFetcher(
  requestTemplates.paymentReceipt,
  rawResponse
);

export const voidPayment = createPaymentApiFetcher(
  requestTemplates.voidPayment,
  envelopedResponse(responseSchemas.PAYMENT)
);

export const refundPayment = createPaymentApiFetcher(
  requestTemplates.refundPayment,
  envelopedResponse(responseSchemas.PAYMENT)
);

export const getClients = createPaymentApiFetcher(
  requestTemplates.clients,
  envelopedResponse(responseSchemas.CLIENTS)
);

export const getPeriscopeDashboard = createPaymentApiFetcher(
  requestTemplates.periscopeDashboard,
  envelopedResponse(responseSchemas.DASHBOARD)
);

// user_management_service

export const getOktaAdministeredUsers = createUserManagementServiceFetcher(
  requestTemplates.getOktaAdministeredUsers,
  unenvelopedResponse(responseSchemas.ADMINISTERED_OKTA_USERS)
);

export const getRoleCombinationsConfig = createUserManagementServiceFetcher(
  requestTemplates.roleCombinationsConfig,
  unenvelopedResponse(responseSchemas.ROLE_COMBINATIONS_CONFIG)
);

export const checkOktaUser = createUserManagementServiceFetcher(
  requestTemplates.checkOktaUser,
  unenvelopedResponse(responseSchemas.EMPTY)
);

export const createOktaUser = createUserManagementServiceFetcher(
  requestTemplates.createOktaUser,
  envelopedResponse(responseSchemas.OKTA_USER)
);

export const editOktaUser = createUserManagementServiceFetcher(
  requestTemplates.editOktaUser,
  envelopedResponse(responseSchemas.OKTA_USER)
);

export const editMyself = createUserManagementServiceFetcher(
  requestTemplates.editMyself,
  envelopedResponse(responseSchemas.OKTA_USER)
);

export const activateOktaUser = createUserManagementServiceFetcher(
  requestTemplates.activateOktaUser,
  envelopedResponse(responseSchemas.OKTA_USER)
);

export const reactivateOktaUser = createUserManagementServiceFetcher(
  requestTemplates.reactivateOktaUser,
  envelopedResponse(responseSchemas.OKTA_USER)
);

export const deactivateOktaUser = createUserManagementServiceFetcher(
  requestTemplates.deactivateOktaUser,
  envelopedResponse(responseSchemas.OKTA_USER)
);

export const resetOktaPassword = createUserManagementServiceFetcher(
  requestTemplates.resetOktaPassword,
  envelopedResponse(responseSchemas.OKTA_PASSWORD_RESET_URL)
);

// frontend_configuration_service

export const getSettingsProfileConfig = createFrontendConfigurationServiceFetcher(
  requestTemplates.settingsProfileConfig,
  unenvelopedResponse(responseSchemas.SETTINGS_PROFILE_CONFIG)
);

export const getSettingsRootConfig = createFrontendConfigurationServiceFetcher(
  requestTemplates.settingsRootConfig,
  unenvelopedResponse(responseSchemas.SETTINGS_ROOT_CONFIG)
);

export const getMetaConfig = createFrontendConfigurationServiceFetcher(
  requestTemplates.metaConfig,
  unenvelopedResponse(responseSchemas.META_CONFIG)
);

// conduit_gateway

export const getIntegrations = createConduitGatewayFetcher(
  requestTemplates.getIntegrations,
  rawResponse
);

export const getIntegration = createConduitGatewayFetcher(
  requestTemplates.getIntegration,
  rawResponse
);

export const getIntegrationAgencies = createConduitGatewayFetcher(
  requestTemplates.getIntegrationAgencies,
  rawResponse
);

export const newIntegration = createConduitGatewayFetcher(
  requestTemplates.newIntegration,
  rawResponse
);

export const createIntegration = createConduitGatewayFetcher(
  requestTemplates.createIntegration,
  rawResponse
);

export const updateIntegration = createConduitGatewayFetcher(
  requestTemplates.updateIntegration,
  rawResponse
);

export const submitIntegration = createConduitGatewayFetcher(
  requestTemplates.submitIntegration,
  rawResponse
);

export const unsubmitIntegration = createConduitGatewayFetcher(
  requestTemplates.unsubmitIntegration,
  rawResponse
);

export const resetIntegrationToDraft = createConduitGatewayFetcher(
  requestTemplates.resetIntegrationToDraft,
  rawResponse
);

export const approveIntegration = createConduitGatewayFetcher(
  requestTemplates.approveIntegration,
  rawResponse
);

export const activateIntegration = createConduitGatewayFetcher(
  requestTemplates.activateIntegration,
  rawResponse
);

export const rejectIntegration = createConduitGatewayFetcher(
  requestTemplates.rejectIntegration,
  rawResponse
);
